@if (label() || hint()) {
  <div class="field-label-row">
    @if (label()) {
      <span class="field-label">
        {{ label() }}
        @if (required()) {
          <span class="field-required">*</span>
        }
      </span>
    }
    @if (hint()) {
      <span class="field-hint">{{ hint() }}</span>
    }
  </div>
}

<div
  class="combobox-wrapper"
  #triggerRef
  [class.combobox-open]="isOpen()"
  [class.combobox-open-above]="isOpen() && opensAbove()"
>
  <div class="combobox-control">
    <input
      #searchInput
      class="combobox-input"
      type="text"
      [placeholder]="isOpen() ? searchPlaceholder() : placeholder()"
      [disabled]="disabled()"
      [value]="inputDisplayValue()"
      (focus)="onInputFocus()"
      (input)="onSearchInput($event)"
    />

    @if (hasValue() && !disabled()) {
      <button
        type="button"
        class="combobox-clear"
        aria-label="Limpar seleção"
        (mousedown)="$event.preventDefault()"
        (click)="clearSelection($event)"
      >
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    }

    <i
      class="fa-solid fa-chevron-down combobox-arrow cursor-pointer"
      aria-hidden="true"
      (mousedown)="$event.preventDefault()"
      (click)="open()"
    ></i>
  </div>

  @if (isOpen()) {
    <ul class="combobox-menu" role="listbox" [ngStyle]="panelStyles()">
      @if (filteredOptions().length === 0) {
        <li class="combobox-empty">Nenhuma opção encontrada</li>
      } @else {
        @for (opt of filteredOptions(); track opt.value) {
          <li
            class="combobox-item"
            role="option"
            [class.combobox-item-selected]="opt.value === value()"
            [attr.aria-selected]="opt.value === value()"
            (mousedown)="$event.preventDefault()"
            (click)="select(opt)"
          >
            {{ opt.label }}
          </li>
        }
      }
    </ul>
  }
</div>

@if (displayMessage()) {
  <span class="field-message" [class.field-message-error]="hasError()">
    @if (hasError()) {
      <i class="fa-solid fa-circle-exclamation field-message-icon" aria-hidden="true"></i>
    }
    {{ displayMessage() }}
  </span>
}
